import { TOTP_PROVIDER_AMPLITUDE_EVENT } from '../../constants';
import AmplitudeUtils from '../../utils/amplitude-utils';
import ProxyButton from '../../components/common/ProxyButton';
import React from 'react';
import BaseForgeCustomizer from '../base-forge';

export default class BarcodePushCustomizer extends BaseForgeCustomizer {
  displayFooterText = true;

  async shouldCustomize() {
    return [ 'barcode-push' ].includes(this.context?.controller);
  }

  protected forgifyController() {
    AmplitudeUtils.logMfaEnrollEvent(`${TOTP_PROVIDER_AMPLITUDE_EVENT[this.provider]}TotpBarcodeScan::Landing`);
    super.forgifyController();
    this.forgifyRefreshCodeText();
    this.forgifyScanInstructionsText();
    this.forgifyCantScanButton();
  }

  private forgifyRefreshCodeText() {
    const refreshQrCodeLink = jQueryCourage('.refresh-qrcode');
    if (refreshQrCodeLink.length) {
      const forgeComponent = <ProxyButton oktaButton={refreshQrCodeLink} variant="tertiary" fullWidth />;
      this.renderForgeAndHideOktaComponent({
        id: 'refresh-qrcode',
        className: 'refresh-qrcode',
        oktaComponent: refreshQrCodeLink,
        forgeComponent: forgeComponent,
      });
    }
  }

  protected forgifyScanInstructionsText() {
    const scanInstructionsDetails = jQueryCourage('.scan-instructions-details').eq(0);
    if (scanInstructionsDetails.length) {
      const forgeComponent = <p className="scan-instructions-details">{scanInstructionsDetails.text()}</p>;
      this.renderForgeAndHideOktaComponent({
        id: scanInstructionsDetails.attr('class')!,
        oktaComponent: scanInstructionsDetails,
        forgeComponent: forgeComponent,
      });
    }
  }

  protected forgifyCantScanButton() {
    const cantScanLink = jQueryCourage('.manual-setup');
    if (cantScanLink.length) {
      const forgeComponent = <ProxyButton oktaButton={cantScanLink} fullWidth variant="tertiary" />;
      this.renderForgeAndHideOktaComponent({
        id: cantScanLink.attr('class')!,
        oktaComponent: cantScanLink,
        forgeComponent: forgeComponent,
      });
    }
  }
}
